import _defineProperty from 'babel-runtime/helpers/defineProperty';

var _headers;

/* eslint-disable shopify/jquery-dollar-sign-reference */
/**
 * Cart methods
 * -----------------------------------------------------------------------------
 *
 * @namespace cart
 */

import axios from 'axios';
// date picker component
import flatPickr from 'vue-flatpickr-component';
import 'flatpickr/dist/flatpickr.css';

// IE11 bug: we need to disable cache for this request
var axiosConfig = {
  headers: (_headers = {
    'Cache-Control': 'must-revalidate'
  }, _defineProperty(_headers, 'Cache-Control', 'no-cache'), _defineProperty(_headers, 'Cache-Control', 'no-store'), _defineProperty(_headers, 'Pragma', 'no-cache'), _headers)
};
var chainCustom = null;
var cartMethods = {
  components: {
    flatPickr: flatPickr
  },

  data: function data() {
    return {
      isCartAjaxed: false,
      loadingEvent: null,
      cart: {},
      cartPromo: {},
      addedGiftItemId: '',
      isGiftItemAdded: false,
      giftContainsItem: false,

      // shipping calculator
      countries: window.Countries,
      provinces: null,
      selectedCountry: null,
      selectedProvince: null,
      selectedZip: null,
      zipRequired: false,
      shippingRates: null,
      shippingRatesErrors: null,

      // date picker
      // get more from https://chmln.github.io/flatpickr/options/
      datePickerConfig: {
        wrap: true, // set wrap to true only when using 'input-group'
        altFormat: 'M j, Y',
        altInput: true,
        dateFormat: 'm-d-Y',
        enableTime: false,
        locale: {
          firstDayOfWeek: 1 // start week on Monday
        },
        // minDate: "today",
        minDate: new Date().fp_incr(2), // 2 days from now

        // disable Saturdays and Sundays - disable using a function
        disable: [function (date) {
          // must return true to disable
          return date.getDay() === 6 || date.getDay() === 0;
        }]
      }
    };
  },


  watch: {
    selectedCountry: function selectedCountry() {
      var selectedCountryObj = app.countries[app.selectedCountry];
      var selectedProvincesObj = selectedCountryObj.province_alternate_names;
      var provincesLength = Object.keys(selectedProvincesObj).length;

      // clear data
      app.shippingRates = null;
      app.shippingRatesErrors = null;
      app.selectedZip = null;

      // set data
      app.zipRequired = selectedCountryObj.zip_required;

      if (provincesLength > 0) {
        app.provinces = selectedProvincesObj;
        // app.selectedProvince = Object.keys(app.provinces)[0]
      } else {
        app.provinces = null;
      }
    }
  },

  methods: {
    _initCart: function _initCart() {
      var isCartAjaxed = $('[data-template="cart"]').data('cart-ajaxed');

      if ($(".pplr-wrapper input.pplr_text.pplr_monogram").length > 0) {
        $(".pplr-wrapper input.pplr_text.pplr_monogram").keyup(function () {

          var selectedFont = $(".pplr_thumb_image .pplr-swatch-element.selected");
          if ($(selectedFont).length > 0) {
            if ($(selectedFont).text().indexOf('LARK') > -1 || $(selectedFont).text().indexOf('GRAVIS') > -1) {
              $(this).css({ "text-transform": "uppercase" });
            }
          } else {
            $(this).css({ "text-transform": "uppercase" });
          }
        });
      }

      $(".pplr_thumb_image .pplr-swatch-element").each(function (i, ele) {
        $(ele).click(function () {
          var selectedFont = $(".pplr_thumb_image .pplr-swatch-element.selected");
          if ($(selectedFont).text().indexOf('LARK') > -1 || $(selectedFont).text().indexOf('GRAVIS') > -1) {
            $(".pplr-wrapper.pplr_show_preview input.pplr_text.pplr_monogram").css({ "text-transform": "uppercase" });
          }
        });
      });

      if (isCartAjaxed) {
        app.isCartAjaxed = true;
      }

      app._getCartData();
      // shipping calculator
      app._initShippingCalculator();
    },
    _addToChain: function _addToChain(variantId, productTitle, productPrice, event) {
      chainCustom = variantId;
      var labelFinal = productTitle + ' Price: ' + app._formatMoney(productPrice);
      $('#selectedChain').html('' + labelFinal);
      $('.close').trigger('click');
    },
    _mergeObjs: function _mergeObjs(def, obj) {
      if (typeof obj === 'undefined') {
        return def;
      } else if (typeof def === 'undefined') {
        return obj;
      }
      for (var i in obj) {
        if (obj[i] != null && obj[i].constructor === Object) {
          def[i] = app._mergeObjs(def[i], obj[i]);
        } else {
          def[i] = obj[i];
        }
      }
      return def;
    },
    _getCartDefault: function _getCartDefault() {
      return axios.get('/cart.js', axiosConfig);
    },
    _getCartExtra: function _getCartExtra() {
      return axios.get('/cart?view=extra.json', axiosConfig);
    },


    /**
     * Get the cart data json object
     */
    _getCartData: function _getCartData() {

      // we make our own enhanced version of the cart object.
      // we are merging Shopify's default cart object
      // and some more additional data like product options and metafields
      // eslint-disable-next-line promise/catch-or-return
      axios.all([app._getCartDefault(), app._getCartExtra()]).then(axios.spread(function (basic, extra) {
        // Both requests are now complete
        var basicCartData = basic.data;
        var mergedItems = app._mergeObjs(basic.data.items, extra.data.items);
        basicCartData.items = mergedItems;

        basicCartData.items.forEach(function (item) {
          if (!item.properties) {
            item.properties = [];
          }
        });

        app.cart = basicCartData;
        app._initCartUpsells();
        app._initCartPromos();

        var itemCountCust = app.cart.item_count;
        var checkSub = 0;
        $.each(app.cart.items, function (i, e) {
          if (e.checkSubBundle === true) {
            checkSub += e.quantity;
          }
        });
        app.cart.totalExBundle = itemCountCust - checkSub;
        if (app.currentTemplate === 'cart') {
          $('[data-cart-giftcard-close]').trigger('click');
        }

        app._addPromoMessage(basic.data.total_price);
        app._checkDiscount();
        console.log('_getCartData', basic.data);
      }));
    },


    /**
     * Event to add a variant to the cart
     * adds item properties from hidden fields automatically
     *
     * @param  {number} variantId - current variant id
     */
    _addToCart: function _addToCart(variantId, event) {
      console.log('_addToCart');
      var $form = $(event.currentTarget).closest(app.selectors.productForm);
      var $atcModal = $(event.currentTarget).closest('[data-product-card]').siblings('.add-chain-popup');
      var $qtyEl = $form.find(app.selectors.qtyInput);
      var qtyValue = $qtyEl.val() || 1;
      var productCartLimit = $(event.currentTarget).attr('data-cart-limit') || null;
      var cartProduct = app.cart.items.find(function (x) {
        return x.variant_id === variantId;
      });
      var totalQty = cartProduct ? Number(qtyValue) + Number(cartProduct.quantity) : qtyValue;
      var properties = {};
      var productAddons = app.storeUtilities.productAddons.products;
      Shopify.queue = [];
      var addOns = [];
      // For 4 checkboxes validation

      console.log('form', $form.hasClass('gift-product'));
      if (!$form.hasClass('gift-product')) {
        if ($(".product-personalizer").length > 0) {
          if ($(".pplr-wrapper.pplr-choose-your-font").length > 0) {
            if ($(".pplr_thumb_image .pplr-swatch-element.selected").length == 0) {
              alert('Please select any font');
              return false;
            }
          }
          if ($(".pplr-wrapper input.pplr_text.pplr_monogram").length > 0) {
            var inputText = $(".pplr-wrapper input.pplr_text.pplr_monogram").val();
            $(".pplr-wrapper input.pplr_text.pplr_monogram").focus();
            if (inputText == "") {
              alert('Please enter the initial text');
              return false;
            }
          }
        }
        if ($('#agree_checkbox').length > 0) {
          var totalCount = $('#agree_checkbox input[type="checkbox"]').length;
          var totalChecked = $('#agree_checkbox input[type="checkbox"]:checked').length;
          if (totalCount !== totalChecked) {
            alert('Please accept terms and conditions in order to add your custom product to the cart.');
            return false;
          }
        }
        if ($('#selectLetters').length > 0) {
          if ($('#selectLetters select').val() === '') {
            $('#selectLetters select').focus();
            alert('Please select any letter');
            return false;
          }
        }
      }

      // For enter initals
      // if ($('#enterInitials').length > 0) {
      //   // eslint-disable-next-line
      //   if ($('#enterInitials input[type="text"]').val() == '') {
      //     $('#enterInitials input[type="text"]').focus();
      //     alert("Please specify the product's required option(s).");
      //     return false;
      //   }
      // }


      // add cart limit property
      if (productCartLimit) {
        properties.cart_limit = productCartLimit;
      }

      // check if item has product limit assigned
      if (app._productHasCartLimit(totalQty, productCartLimit)) {
        return;
      }

      app.isLoading = true;
      app.loadingEvent = 'cartAdding';

      // Pass all properties to the cart line item
      $.each($('input[name*="properties"]').serializeArray(), function () {
        var name = this.name.replace('properties[', '').replace(']', '');
        var selectedFont = $(".pplr_thumb_image .pplr-swatch-element.selected");

        if ($(selectedFont).length > 0) {
          if ($(selectedFont).text().indexOf('LARK') > -1 || $(selectedFont).text().indexOf('GRAVIS') > -1) {
            properties[name] = this.value.toUpperCase();
          } else {
            properties[name] = this.value;
          }
        } else if (name.search("Text") != -1 || name.search("Initials") != -1) {
          properties[name] = this.value.toUpperCase();
        } else {
          properties[name] = this.value;
        }
      });

      // ReCharge Integration
      // if product is a subscription one use the reCharge Discount VariantId
      if ('subscription_id' in properties) {
        properties.shipping_interval_frequency = $('[name="properties[shipping_interval_frequency]"]').val();
        variantId = app.reChargeDiscountVariantId;
      }

      if ($('#bundleProduct').length > 0) {
        $('#bundleProduct .mb-3').each(function (i, e) {
          var randomNumber = $('#MainBundleRandom').val();
          // eslint-disable-next-line radix
          var variantId = parseInt($(this).attr('data-variant'));
          var qty = $('input', this).val();
          var prodTitle = $(this).attr('data-product-title');
          var prodPrice = $(this).attr('data-product-price');
          properties[prodTitle] = qty + ' x ' + prodTitle + ' * ' + prodPrice;
          var BundleId = 'BundleId';
          Shopify.queue.push({
            variantId: variantId,
            qtyValue: qty,
            properties: { BundleId: randomNumber, Bundle: 'SubBundle' }
          });
        });
      }

      // push the default variantId to the Shopify queue
      Shopify.queue.push({
        qtyValue: qtyValue,
        variantId: variantId,
        properties: properties
      });

      // if there are selected product add-ons
      // push them also to the Shopify queue
      if (productAddons.length > 0) {
        productAddons.forEach(function (product) {
          if (product.selected) {
            Shopify.queue.push({
              qtyValue: 1,
              variantId: product.variants[0].id
            });
          }
        });
      }

      if (chainCustom != null) {
        Shopify.queue.push({
          qtyValue: 1,
          variantId: chainCustom
        });
      }
      Shopify.moveAlong = function () {
        // If we still have requests in the queue, let's process the next one.
        if (Shopify.queue.length) {
          var request = Shopify.queue.shift();

          axios.post('/cart/add.js', {
            quantity: request.qtyValue,
            id: request.variantId,
            properties: request.properties
          }).then(function (response) {
            Shopify.moveAlong();
            return response.data;
          }).catch(function (error) {
            // console.log(error)
            Rollbar.critical('Filename: cart.js, Error occurs while add to cart: ' + error);
            if (Shopify.queue.length) {
              Shopify.moveAlong();
            }
            throw error;
          });
        } else {
          if (app.currentTemplate === 'cart' && !app.isCartAjaxed) {
            location.reload();
          }
          app._getCartData();
          app._vibrateDevice();
          $qtyEl.val(1); // reset qty input to 1
          app.$snotify.clear();
          $('[data-template="quickshop"]').modal('hide');
          $('#giftCardPopup').modal('hide');

          setTimeout(function () {
            app.isLoading = false;
            app.loadingEvent = null;

            if (app.storeUtilities.cartUpsells.settings.showOnPopUp) {
              var recentItem = app.cart.items.find(function (x) {
                return x.variant_id === variantId;
              });
              app._openModalCartUpsell(recentItem);
            } else {
              app._toggleCartDrawer();
            }
            // $('[data-add-cart-popup]').trigger('click');
            //if(app.currentTemplate == 'collection'){
            //$atcModal.modal('show');
            // }
          }, 500);
        }
      };
      Shopify.moveAlong();

      var productHandle = $(event.currentTarget).attr('data-product-handle');
      //console.log('productHandle', productHandle);
      if (productHandle != '' && productHandle != undefined && productHandle != null) {
        var currentVariantPrice = $(event.currentTarget).attr('data-current-variant-price');
        axios.get('/products/' + productHandle + '.js').then(function (response) {
          var productJson = response.data;
          // console.log("Product Object: ", productJson);
          dataLayer.push({ ecommerce: null }); // Clear the previous ecommerce object.
          dataLayer.push({
            event: "add_to_cart",
            ecommerce: {
              currency: window.Shopify.currency.active,
              value: productJson.price / 100,
              items: [{
                item_id: productJson.id,
                item_name: productJson.title,
                affiliation: "Google Merchandise Store",
                index: 0,
                item_brand: productJson.vendor,
                item_variant: variantId,
                location_id: "",
                price: currentVariantPrice / 100,
                quantity: qtyValue
              }]
            }
          });
          console.log('dataLayer', dataLayer);
        }).catch(function (error) {
          console.log(error);
          Rollbar.error('Filename: cart.js, Error occurs while add to cart: ' + error);
          throw error;
        });
      }
    },


    /**
     * Event to remove a variant from the cart
     *
     * @param  {number} itemId - line item index
     */
    _removeFromCart: function _removeFromCart(itemIndex, event) {
      // console.log(itemIndex);
      var $cartItem = $(event.currentTarget).parentsUntil(app.selectors.cartItem).parent();

      // console.log('_removeFromCart', $cartItem.length);
      if ($cartItem.length) {
        dataLayer.push({ ecommerce: null });
        dataLayer.push({
          event: "remove_from_cart",
          ecommerce: {
            currency: window.Shopify.currency.active,
            value: app.cart.total_price / 100,
            items: [{
              item_id: $cartItem.attr('data-item-id'),
              item_name: $cartItem.attr('data-item-title'),
              affiliation: "Google Merchandise Store",
              discount: app.cart.total_discount,
              index: 0,
              item_brand: $cartItem.attr('data-item-vendor'),
              // item_category: e.currentTarget.getAttribute('data-collection'),
              item_list_id: "remove_from_cart_" + $cartItem.attr('data-item-sku'),
              item_list_name: "Remove From Cart " + $cartItem.attr('data-item-title'),
              item_variant: $cartItem.attr('data-variant-id'),
              location_id: "",
              price: $cartItem.attr('data-item-price') / 100,
              quantity: $cartItem.attr('data-item-quantity')
            }]
          }
        });
        console.log('dataLayer', dataLayer);
      }

      app.isLoading = true;
      $cartItem.addClass('updating');
      axios.post('/cart/change.js', {
        quantity: 0,
        line: itemIndex
      }).then(function (response) {
        app.isLoading = false;
        app._addGiftCard(response.data.total_price);
        app._addPromoMessage(response.data.total_price);
        app._checkDiscount();
        app._getCartData();
        $('[data-toggle="tooltip"]').tooltip('hide');
        return response;
      }).catch(function (error) {
        // console.log(error)
        Rollbar.error('Filename: cart.js, Error occurs while Remove Product from cart ' + error);
        throw error;
      });
    },
    _removeBundleFromCart: function _removeBundleFromCart(itemIndex, event) {
      var data = [];
      var $bundleId = $(event.currentTarget).attr('data-chkbundle');
      $('.form-main-cart [data-cart-item]').each(function (e, i) {
        var $this = $(this);
        var qty = $this.find('[data-qty-input]').val();
        var data_sub = {};
        if ($this.attr('data-bundleId') === $bundleId) {
          data_sub = 0;
        } else {
          data_sub = qty;
        }
        data.push(data_sub);
      });
      var updatedCart = {};
      updatedCart.updates = data;
      var params = {
        type: 'POST',
        url: '/cart/update.js',
        data: updatedCart,
        dataType: 'json',
        success: function success(cart) {
          $.ajax({
            url: '/cart',
            type: 'GET',
            dataType: 'html',
            success: function success(data) {
              app.isLoading = false;
              app._getCartData();
              $('[data-toggle="tooltip"]').tooltip('hide');
              return data;
            }
          });
        },
        error: function error(XMLHttpRequest, textStatus) {
          console.log(XMLHttpRequest);
          Rollbar.error('Filename: cart.js, Error occurs while Remove _removeBundleFromCart ' + XMLHttpRequest);
        }
      };
      $.ajax(params);
    },

    /**
     * Event to update a variant in the cart
     *
     * @param  {number} itemIndex - line item index
     */
    _updateCart: function _updateCart(itemIndex, event) {

      var $qtyEl = $(event.currentTarget).parentsUntil(app.selectors.qtyContainer).find(app.selectors.qtyInput);
      var $cartItem = $(event.currentTarget).closest(app.selectors.cartItem);
      var productCartLimit = $cartItem.data('cart-limit') || null;
      var qtyValue = $qtyEl.val();

      if ($(event.currentTarget).data('qty-decrease') !== undefined) {
        if (parseFloat(qtyValue) >= 1) {
          qtyValue = parseFloat(qtyValue) - 1;
        }
      } else if ($(event.currentTarget).data('qty-increase') !== undefined) {
        qtyValue = parseFloat(qtyValue) + 1;

        // check if item has product limit assigned
        if (app._productHasCartLimit(qtyValue, productCartLimit)) {
          return;
        }
      }

      app.isLoading = true;
      $cartItem.addClass('updating');

      $($qtyEl).parent().css({
        'pointer-events': 'none'
      });

      if (qtyValue == 0) {
        //  console.log('_updateCart', $cartItem.length);
        if ($cartItem.length) {
          dataLayer.push({ ecommerce: null });
          dataLayer.push({
            event: "remove_from_cart",
            ecommerce: {
              currency: window.Shopify.currency.active,
              value: app.cart.total_price / 100,
              items: [{
                item_id: $cartItem.attr('data-item-id'),
                item_name: $cartItem.attr('data-item-title'),
                affiliation: "Google Merchandise Store",
                discount: app.cart.total_discount,
                index: 0,
                item_brand: $cartItem.attr('data-item-vendor'),
                // item_category: e.currentTarget.getAttribute('data-collection'),
                item_list_id: "remove_from_cart_" + $cartItem.attr('data-item-sku'),
                item_list_name: "Remove From Cart " + $cartItem.attr('data-item-title'),
                item_variant: $cartItem.attr('data-variant-id'),
                location_id: "",
                price: $cartItem.attr('data-item-price') / 100,
                quantity: $cartItem.attr('data-item-quantity')
              }]
            }
          });
          console.log('dataLayer', dataLayer);
        }
      }

      axios.post('/cart/change.js', {
        quantity: qtyValue,
        line: itemIndex
      }).then(function (response) {
        app._addGiftCard(response.data.total_price);
        app._addPromoMessage(response.data.total_price);
        app._checkDiscount();
        app._getCartData();
        app.isLoading = false;
        $cartItem.removeClass('updating');
        $($qtyEl).parent().css({
          'pointer-events': 'inherit'
        });
        return response;
      }).catch(function (error) {
        // console.log(error)
        Rollbar.error('Filename: cart.js, Error occurs while Product update from cart ' + error);
        throw error;
      });
    },
    _updateBundleCart: function _updateBundleCart(itemIndex, event) {
      var BundleId = $(event.currentTarget).parents('[data-cart-item]').attr('data-bundleid');
      var $qtyEl = $(event.currentTarget).parentsUntil(app.selectors.qtyContainer).find(app.selectors.qtyInput);
      var $cartItem = $(event.currentTarget).closest(app.selectors.cartItem);
      var productCartLimit = $cartItem.data('cart-limit') || null;
      var qtyValue = $qtyEl.val();

      if ($(event.currentTarget).data('qty-decrease') !== undefined) {
        if (parseFloat(qtyValue) >= 2) {
          qtyValue = parseFloat(qtyValue) - 1;
        }
      } else if ($(event.currentTarget).data('qty-increase') !== undefined) {
        qtyValue = parseFloat(qtyValue) + 1;
        // check if item has product limit assigned
        if (app._productHasCartLimit(qtyValue, productCartLimit)) {
          return;
        }
      }
      app.isLoading = true;
      $cartItem.addClass('updating');

      $($qtyEl).parent().css({
        'pointer-events': 'none'
      });
      var data = [];
      $('.form-main-cart [data-cart-item]').each(function (e, i) {
        var $this = $(this);
        var bundleType = $this.attr('data-bundleType');
        var qty = $this.find('[data-qty-input]').val();
        var data_sub = {};
        if ($this.attr('data-bundleid') === BundleId) {
          if (bundleType) {
            data_sub = qtyValue;
          } else {
            var chkMainQty = parseInt(qty, 10) / parseInt($qtyEl.val(), 10);
            data_sub = parseInt(qtyValue, 10) * parseInt(chkMainQty, 10);
          }
        } else {
          data_sub = qty;
        }
        data.push(data_sub);
      });
      var updatedCart = {};
      updatedCart.updates = data;
      var params = {
        type: 'POST',
        url: '/cart/update.js',
        data: updatedCart,
        dataType: 'json',
        success: function success(cart) {
          $.ajax({
            url: '/cart',
            type: 'GET',
            dataType: 'html',
            success: function success(data) {
              app._getCartData();
              app.isLoading = false;
              $cartItem.removeClass('updating');
              $($qtyEl).parent().css({
                'pointer-events': 'none'
              });
              setTimeout(function () {
                $($qtyEl).parent().css({
                  'pointer-events': 'inherit'
                });
                app.cartLoading = true;
              }, 1500);
              return data;
            }
          });
        },
        error: function error(XMLHttpRequest, textStatus) {
          console.log(XMLHttpRequest);
          Rollbar.error('Filename: cart.js, Error occurs while update cart event: ' + XMLHttpRequest);
        }
      };
      $.ajax(params);
    },
    _productHasCartLimit: function _productHasCartLimit(qtyValue, productCartLimit) {
      // console.log(`qtyValue: ${qtyValue}, productCartLimit: ${productCartLimit}`);
      if (productCartLimit) {
        if (qtyValue > productCartLimit) {
          app.$snotify.warning('Product cart limit applies for the specific product variant. You can\'t purchase more than ' + productCartLimit + ' item(s) per order.', 'Product Limit', {
            timeout: 10000,
            showProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            buttons: [{
              text: 'Close',
              bold: true,
              closeOnClick: true
              // action: (toast) => {
              //   app.$snotify.remove(toast.id);
              // },
            }]
          });
          return true;
        }
      }
      return false;
    },


    /**
     * ShippingCalculator
     */
    _initShippingCalculator: function _initShippingCalculator() {
      var $form = $('[data-shipping-calculator]');
      if ($form.length === 0) {
        return;
      }

      var customerCountry = $form.find('select[name="country"]').data('value').trim();
      var customerProvince = $form.find('select[name="province"]').data('value').trim();
      var customerZip = $form.find('input[name="zip"]').data('value').trim();
      var userCountry = app._getCookie('user_country');
      var userProvince = app._getCookie('user_province');
      var today = new Date();
      var expirationDate = new Date();
      expirationDate.setDate(today.getDate() + 7);
      var time = expirationDate.getTime();
      var expireTime = time + 1000 * 36000;
      expirationDate.setTime(expireTime);

      if (customerCountry) {
        // if is user (is logged-in) show the user data
        app.selectedCountry = customerCountry;
        app.selectedProvince = customerProvince;
        app.selectedZip = customerZip;
      } else if (userCountry !== 'user_country' && userProvince !== 'user_province') {
        // else if cookie exists get from cookie
        app.selectedCountry = userCountry;
        app.selectedProvince = userProvince;
      } else {
        // finally if we don't have any data => get info from IP
        axios.get('https://geoip-db.com/json/').then(function (response) {
          app.selectedCountry = response.data.country_name;
          app.selectedProvince = response.data.region_name;
          // app.selectedZip = response.data.zip_code

          // set cookies
          document.cookie = 'user_country=' + response.data.country_name + ';expires=' + expirationDate.toGMTString() + ';path=/';
          document.cookie = 'user_province=' + response.data.region_name + ';expires=' + expirationDate.toGMTString() + ';path=/';
          return response;
        }).catch(function (error) {
          // console.log(error)
          throw error;
        });
      }
    },
    _getCartShippingRates: function _getCartShippingRates() {
      app.isLoading = true;

      axios.post('/cart/prepare_shipping_rates', {
        shipping_address: {
          country: app.selectedCountry,
          province: app.selectedProvince,
          zip: app.selectedZip
        }
      }).then(function (response) {
        app._pollCartShippingRates();
        return response;
      }).catch(function (error) {
        // console.log(error.response.data)
        Rollbar.error('Filename: cart.js, Error occurs while _getCartShippingRates: ' + error);
        app.isLoading = false;
        app.shippingRatesErrors = error.response.data;
        throw error;
      });
    },
    _addPromoMessage: function _addPromoMessage(totalPrice) {

      app.cartPromo = JSON.parse($('[data-promo-json]').html());
      //console.log(app.cartPromo);
      console.log(totalPrice, app.cartPromo.free_shipping_threshold);
      if (app.cartPromo.enable_free_shipping_message && totalPrice > 0) {
        $('[data-shipping-bar]').removeClass('d-none');

        var persentage = totalPrice * 100 / app.cartPromo.free_shipping_threshold;
        $('[data-shipping-inner]').css('width', persentage + '%');
        var free_shipping_threshold = app.cartPromo.free_shipping_threshold;
        if (totalPrice < free_shipping_threshold) {
          var away = parseFloat(free_shipping_threshold) - parseFloat(totalPrice);
          $(".promo_message").html("<p>You are " + app._formatMoney(away) + " away from Free Expedited Shipping</p>");
        } else {
          $('[data-shipping-inner]').css('width', '100%');
          $(".promo_message").html(app.cartPromo.free_shipping_message);
        }
      } else {
        $('[data-shipping-bar]').addClass('d-none');
      }
      console.log('away', app._formatMoney(away));
      if (app.cartPromo.enable_free_product_message) {
        var free_product_threshold = app.cartPromo.free_product_threshold;
        var free_product = app.cartPromo.free_product;
        if (totalPrice < free_product_threshold) {
          var away = parseFloat(free_product_threshold) - parseFloat(totalPrice);
          $(".promo_message").html('<p> You are ' + app._formatMoney(away) + ' away from a Free <a href="/products/"' + free_product.handle + '">' + free_product.title + '</a> </p>');
        } else {
          $(".promo_message").html('<p class="text-center">Your order qualifies for a FREE' + free_product.title + '.<br>Use Code: <b>' + app.cartPromo.promocode + '</b> at checkout.</p>');
        }
      }
    },
    _addGiftCard: function _addGiftCard(totalPrice) {
      var removeCartUpdates = {};
      var cartUpdates = {};
      var variantId = null;
      var giftCardQty = null;
      var arrayGiftVariant = [];

      $.each($(app.selectors.giftCartItems), function (i, input) {
        arrayGiftVariant.push($(input).attr("data-variantId"));
      });
      $.each(app.cart.items, function (i, item) {
        var giftCardPresent = arrayGiftVariant.forEach(function (id) {
          if (id == item.id) {
            app.giftContainsItem = true;
            app.isGiftItemAdded = true;
            app.addedGiftItemId = item.id;
          }
        });
      });
      if (app.isGiftItemAdded) {
        var giftItemId = app.addedGiftItemId;
        removeCartUpdates[giftItemId] = 0;
        app._updateGiftCardProduct(removeCartUpdates);
      }
      if (app.cart.item_count == 1 && app.isGiftItemAdded || $(app.selectors.giftCartItems).length == 0) {
        return;
      }
      if (app.cart.item_count > 0 && totalPrice >= 7500) {
        if (totalPrice >= 7500 && totalPrice <= 12400) {
          giftCardQty = $('[data-gift-1000]').attr("data-gift-qty");
          variantId = $('[data-gift-1000]').val();
        } else if (totalPrice >= 12500 && totalPrice <= 17400) {
          giftCardQty = $('[data-gift-2000]').attr("data-gift-qty");
          variantId = $('[data-gift-2000]').val();
        } else if (totalPrice >= 17500) {
          giftCardQty = $('[data-gift-3000]').attr("data-gift-qty");
          variantId = $('[data-gift-3000]').val();
        }
        cartUpdates[variantId] = giftCardQty;
        setTimeout(function () {
          app._updateGiftCardProduct(cartUpdates);
        }, 1200);
      }
    },
    _updateGiftCardProduct: function _updateGiftCardProduct(cartUpdates, Type) {
      var data = {
        type: 'POST',
        url: '/cart/update.js',
        data: { updates: cartUpdates, properties: { 'promo_product': 'gift_card' } },
        dataType: 'json',
        success: function success(data) {
          app.performGiftFunction = Type;
          app._getCartData();
        },
        error: function error(XMLHttpRequest, textStatus) {
          console.log(XMLHttpRequest);
          Rollbar.error('Filename: cart.js, Error occurs while _updateGiftCardProduct event: ' + XMLHttpRequest);
        }
      };
      $.ajax(data);
    },
    _pollCartShippingRates: function _pollCartShippingRates() {
      axios.get('/cart/async_shipping_rates').then(function (response) {
        app.isLoading = false;
        if (response.data && response.data.shipping_rates) {
          app.shippingRates = response.data.shipping_rates;
        }
        return response;
      }).catch(function (error) {
        // console.log(error)
        Rollbar.error('Filename: cart.js, Error occurs while _pollCartShippingRates event: ' + error);
        throw error;
      });
    },


    /**
     * Vibrate mobile device
     */
    _vibrateDevice: function _vibrateDevice() {
      // check for vibration support
      var vibrationEnabled = navigator.vibrate || navigator.webkitVibrate || navigator.mozVibrate || navigator.msVibrate;
      if (vibrationEnabled) {
        navigator.vibrate(100);
      }
    }
  }
};

export default cartMethods;